/**
 *
 *
 * @author Erik Jan Lam
 * @date Mar 26 2019
 */

var util = require('./utils');

/**
 * Handle slider input changes.
 * @param sliders
 * @param elements
 */
function onSliderChange(sliders, elements, currencyFormat) {
    // get lowest and highest value;
    var min = Math.min(sliders[0].value, sliders[1].value);
    var max = Math.max(sliders[0].value, sliders[1].value);
    var minTxt = min;
    var maxTxt = max;

    if (currencyFormat) {
        minTxt = util.formatLocale(
            min,
            currencyFormat.separator,
            0,
            currencyFormat.currencyPosition === 'before' ? currencyFormat.currencyChar : '',
            currencyFormat.currencyPosition === 'after' ? currencyFormat.currencyChar : ''
        );
        maxTxt = util.formatLocale(
            max,
            currencyFormat.separator,
            0,
            currencyFormat.currencyPosition === 'before' ? currencyFormat.currencyChar : '',
            currencyFormat.currencyPosition === 'after' ? currencyFormat.currencyChar : ''
        );
    }

    if (elements.min && elements.max) {
        elements.min.innerText = minTxt;
        elements.max.innerText = maxTxt;
    }

    if (elements.selection) {
        var range = sliders[0].max - sliders[0].min;
        var selectedRange = max - min;
        var rangeWidth = (selectedRange / range) * 100;
        var rangeMin = ((min - sliders[0].min) / range) * 100;
        var rangeMax = rangeMin + rangeWidth;

        elements.selection.style.width = rangeWidth + '%';
        elements.selection.style.left = rangeMin + '%';
    }

    if (elements.min && elements.max) {
        elements.min.style.left = rangeMin + '%';
        elements.max.style.left = rangeMax + '%';
    }

    // update accessibility attributes
    for (var i = 0; i < sliders.length; i++) {
        var sliderVal = Number(sliders[i].value);
        sliders[i].setAttribute('aria-valuenow', sliders[i].value);
        sliders[i].setAttribute(
            'aria-valuetext',
            currencyFormat
                ? util.formatLocale(
                      sliderVal,
                      currencyFormat.separator,
                      0,
                      currencyFormat.currencyPosition === 'before' ? currencyFormat.currencyChar : '',
                      currencyFormat.currencyPosition === 'after' ? currencyFormat.currencyChar : ''
                  )
                : sliderVal
        );
    }
}

/**
 * For IE/Edge, put the slider with it's handle closest to the mouse pointer on top.
 * @param event
 * @param sliders
 */
function selectSlider(event, sliders) {
    var value1 = sliders[0].value;
    var value2 = sliders[1].value;
    var range = sliders[0].max - sliders[0].min;
    var scale = sliders[0].offsetWidth / range;
    var valuePointer = event.offsetX / scale;

    var distanceFrom1 = Math.abs(valuePointer - value1);
    var distanceFrom2 = Math.abs(valuePointer - value2);

    if (distanceFrom1 <= distanceFrom2) {
        sliders[0].style.zIndex = 2;
        sliders[1].style.zIndex = 1;
    } else {
        sliders[0].style.zIndex = 1;
        sliders[1].style.zIndex = 2;
    }
}

function initRangeSlider(root) {
    var sliders = root.querySelectorAll('input[type=range]');
    var elements;
    var onChange;
    var isIE = false;
    var currencyStr = root.dataset.priceFormat;
    var currencyFormat = currencyStr ? util.getCurrencyFormatFromString(currencyStr) : null;
    if (sliders.length < 2) {
        return;
    }

    elements = {
        min: root.querySelector('.value-min'),
        max: root.querySelector('.value-max'),
        selection: root.querySelector('.selected-range'),
        track: root.querySelector('.track')
    };

    onChange = requestAnimationFrame.bind(window, function () {
        onSliderChange(sliders, elements, currencyFormat);
    });

    // need to handle a Edge/IE bug that breaks pointer events on slider handles.
    if (navigator.userAgent.match(/(\sedge|MSIE\s|rv:11)/i)) {
        isIE = true;
    }

    for (var i = 0; i < sliders.length; i++) {
        sliders[i].addEventListener('input', onChange, false);

        if (isIE) {
            sliders[i].classList.add('slider-ms');
            sliders[i].addEventListener('mousemove', function (event) {
                requestAnimationFrame(selectSlider.bind(this, event, sliders));
            });
        }
    }

    onChange();
}

module.exports = initRangeSlider;
